<company-block-card [title]="'POA_TITLE'" [explanationSubTitle]="'COMPANY.POWER_OF_ATTORNEY_RULES'" [isMarginBottom]="true">
  <ng-container card-body>
    <company-sub-block-card [subTitle]="'DOCUMENT_TYPE.POWER_OF_ATTORNEY'" [isShowFooter]="true">
      <ng-container inner-card-actions *ngIf="!isTablet">
        <span class="power-attorney-container-link">
          <a [href]="poaFileUrl" target="_blank" download>
            <span class="power-attorney-container-download-icon-container">
              <icon-download></icon-download>
            </span>
            {{ "DOWNLOAD_BLANK_POA" | translate }}
          </a>
        </span>
      </ng-container>

      <ng-container inner-card-body>
        <div class="d-flex align-items-center">
          <div
            class="power-attorney-container__uploader pl-0 pr-0"
            [ngClass]="{ 'col-12 col-lg-8': isShowDescription, 'col-12': !isShowDescription }"
          >
            <document-upload-desktop
              [id]="'poa-company-old'"
              [attachmentName]="'DOCUMENT_TYPE.POWER_OF_ATTORNEY'"
              [attachmentHint]="'COMPANY.POWER_OF_ATTORNEY_DESC'"
              [footerHint]="'LABELS.DRAG_N_DROP_FOR_UPLOAD_POA'"
              [uploadedDocument]="poaDocument"
              [canUploadDocuments]="true"
              [canRemoveDocuments]="true"
              [isLoading]="isLoadingCompanyPoa"
              [isShowOptionalTag]="false"
              [isShowNormalAddIcon]="true"
              [isStretched]="true"
              [isDividedLayout]="true"
              [isShowLoader]="false"
              [isShowFooter]="false"
              [isRequired]="true"
              (upload)="uploadDocument.emit($event)"
              (remove)="deleteDocument.emit($event)"
              (stateUpdate)="updateDocumentState.emit($event)"
            ></document-upload-desktop>
          </div>
          <div class="d-none d-lg-block pr-lg-0" [ngClass]="{ 'col-4': isShowDescription }" *ngIf="isShowDescription">
            <div class="power-attorney-container__description">
              <span [innerHTML]="'COMPANY.POWER_OF_ATTORNEY_DESCRIPTION' | translate"></span>
            </div>
          </div>
        </div>
      </ng-container>

      <ng-container inner-card-footer *ngIf="isTablet">
        <span class="power-attorney-container-link bordered">
          <a [href]="poaFileUrl" target="_blank" download>
            <span class="power-attorney-container-download-icon-container">
              <icon-download></icon-download>
            </span>
            {{ "DOWNLOAD_BLANK_POA" | translate }}
          </a>
        </span>
      </ng-container>
    </company-sub-block-card>
  </ng-container>
</company-block-card>
